import { SearchDrugListComponent } from './../search-drug-list/search-drug-list.component';
import { ImportWizardAddNewDrugComponent } from './../import-wizard-add-new-drug/import-wizard-add-new-drug.component';
import { FileUploadComponent } from './../file-upload/file-upload.component';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { MatTableDataSource } from '@angular/material/table';
import { DrugCategory } from '../../models/drug';
import { routePaths } from 'src/app/config/app-constants';
import { RpoToolService } from '../../services/rpo-tool.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as constants from 'src/app/config/app-constants';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { QuarantinedDrugListComponent } from '../quarantined-drug-list/quarantined-drug-list.component';
import { DcrDrugListComponent } from '../dcr-drug-list/dcr-drug-list.component';
import { DropDown } from '../../models/dropdown';
import { DropdownValues } from '../../models/synmed-data';
import { ImportWizardNewDrugComponent } from '../import-wizard-new-drug/import-wizard-new-drug.component';
import { MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'app-drug-list',
    templateUrl: './drug-list.component.html',
    styleUrls: ['./drug-list.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class DrugListComponent implements OnInit {

  searchText: string = '';
  dataSource = new MatTableDataSource<DrugCategory>();
  columnsToDisplay = ['name', 'ndc', 'countryCode', 'source', 'system', 'strength', 'manufacturer', 'priority', 'modifiedBy' ,'requestor', 'age', 'action'];
  expandedElement: DrugCategory | null = null;
  DRUGES: DrugCategory[] = [];
  listOfCountry: DropDown[] = [];
  listOfQReason: DropDown[] = [];
  listOfDataSourceFilter: DropDown[] = [];
  permanentQuarantine: DropDown[] = DropdownValues.CommonBooleanDropDownValues;
  selectedSearchCriteria: any;
  validationError: string = '';
  isValid: boolean = true;
  listOfModifiers: DropDown[] = [];
  searchCriteria = [
    {
      value: 'drugNumber',
      label: 'Drug number',
      pattern: /^\d+$/,
      errorMsg: 'Drug number must contain only numbers'
    },
    {
      value: 'drugName',
      label: 'Drug Name',
      pattern: /^[a-zA-Z0-9\s]+$/,
      errorMsg: 'Drug name must contain only letters, numbers and spaces'
    },
    {
      value: 'pdbid',
      label: 'Alternate ID',
      pattern: /^\d+$/,
      errorMsg: 'Alternate ID must contain only numbers'
    },
    {
      value: 'tcgid',
      label: 'TCGID',
      pattern: /^\d+$/,
      errorMsg: 'TCGID must contain only numbers'
    },
    {
      value: 'genericNumber',
      label: 'Generic Number',
      pattern: /^\d+$/,
      errorMsg: 'Generic Number must contain only numbers'
    },
    {
      value: 'barcode',
      label: 'Barcode',
      pattern: /^[a-zA-Z0-9\s]{10}$|^[a-zA-Z0-9\s]{12}$/,
      errorMsg: 'Must be 10 or 12 characters letters, numbers, or spaces'
    },
    {
      value: 'dItem',
      label: 'DItem',
      pattern: /^[a-zA-Z0-9\s]+$/,
      errorMsg: 'DItem must contain only letters, numbers and spaces'
    },
  ];
  listOfCaseOwnersForFilter = ['All', 'Lisa Eleby', 'Travis Morris', 'DCR Queue']
  selectedCaseOwner: string = 'All';


  @ViewChild(SearchDrugListComponent) child?: SearchDrugListComponent;
  @ViewChild(QuarantinedDrugListComponent) quarantinedChild?: QuarantinedDrugListComponent;

  //#region Pagination properties
  totalRows: number = 0;
  currentPage: number = 0;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 20, 40, 50];
  //#endregion
  dataSourceId: number = -1;
  countryId: number = -1;
  qReasonId: number = -1;
  caseOwner: string | null = null;
  statusId: number = 0;
  searchResultsCount: number = 0;
  QuarantineResultsCount: number = 0;
  dcrResultsCount: number = 0;
  permanentQuarantineValue: boolean = true;

    // Add these new properties for debounce functionality
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  private readonly DEBOUNCE_TIME = 700; // 700ms delay

  modifiedBy: string | null = null;
  //#endregion
  constructor(
    private rpoService: RpoToolService,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private route: Router) { }

  ngOnInit(): void {
    this.getCountry();
    this.getQuarantineReasonList();
    this.getDataSourceFilter();
    this.getModifiersList();
    this.selectedSearchCriteria = this.searchCriteria[0];


    // Set up the debounced search
    this.setupDebouncedSearch();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getQReasonTitle(qReasonId: number): string {
    console.log(qReasonId, this.listOfQReason, "qReasonId---");

  // Return empty string if qReasonId is null, undefined, or not a valid number
  if (qReasonId === null || qReasonId === undefined || isNaN(Number(qReasonId))) {
    return '';
  }

  // Check if listOfQReason is a valid array
  if (!Array.isArray(this.listOfQReason) || this.listOfQReason.length === 0) {
    return '';
  }

  // Find the matching QReason by value
  const selectedQReason = this.listOfQReason.find(
    (eachQReason) => eachQReason.value === qReasonId.toString()
  );

  // If not found or label is missing, return empty string
  if (!selectedQReason || typeof selectedQReason.label !== 'string') {
    return '';
  }

  // Return label only if it's longer than 25 characters
  return selectedQReason.label.length > 25 ? selectedQReason.label : 'x';
}

  onCaseOwnerSelectionChange(owner: string) {
    this.selectedCaseOwner = owner;
  }

  /**
    * Method to refresh both child components
    */
  refreshChildComponents() {
    if (this.child) {
      this.child.getDrugData(); // Refresh SearchDrugListComponent
    }

    if (this.quarantinedChild) {
      this.quarantinedChild.getDrugData(); // Refresh QuarantinedDrugListComponent
    }
  }
  onCriteriaSelect(criteria: any) {
    this.selectedSearchCriteria = criteria;

    // If there's text, validate and fetch data if valid
    if (this.searchText && this.searchText.trim() !== '') {
      if (this.validateInput(this.searchText)) {
        this.getDrugData();
      }
    }
  }

  validateInput(value: string): boolean {
    // Allow empty values to work normally
    if (!value || value.trim() === '') {
      this.validationError = '';
      this.isValid = true;
      return true;
    }

    const currentCriteria = this.searchCriteria.find(c => c.value === this.selectedSearchCriteria.value);
    if (!currentCriteria) {
      return false;
    }

    const isValid = currentCriteria.pattern.test(value);
    if (!isValid) {
      this.validationError = currentCriteria.errorMsg;
      this.isValid = false;
      return false;
    }


    if((currentCriteria.value === 'tcgid' ) && (value.length>10) ){
      this.validationError = 'TCGID should not be more then 10 digit';
      this.isValid = false;
      return false;
    }

    if((currentCriteria.value === 'pdbid') && (value.length>10) ){
      this.validationError = 'PDDBID should not be more then 10 digit';
      this.isValid = false;
      return false;
    }

    if((currentCriteria.value === 'barcode') && (value.length!=10 && value.length!=12) ){
      this.validationError = 'Barcode must be 10 or 12 digit';
      this.isValid = false;
      return false;
    }

    this.validationError = '';
    this.isValid = true;
    return true;
  }


  /**
   * Set up debounced search functionality
   */
  private setupDebouncedSearch(): void {
    this.searchSubject
      .pipe(
        debounceTime(this.DEBOUNCE_TIME),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((searchValue: string) => {
        this.performSearch(searchValue);
      });
  }

  /**
   * Perform the actual search operation
   */
  private performSearch(value: string): void {
    const data = this.dataSource.data;
    const searchResultsIndex = data.findIndex(item => item.name.split('(')[0].trim() === 'SEARCH RESULTS');

    if (searchResultsIndex !== -1) {
      // Now set isExpanded to true
      data[searchResultsIndex].isExpanded = true; // Expand the item

      // Refresh data source with updated data
      this.dataSource.data = [...data];
      console.log(this.dataSource.data, "this.dataSource.data");
    }

    this.searchText = value;

    // For empty value, clear error and fetch data
    if (!value || value.trim() === '') {
      this.validationError = '';
      this.isValid = true;
      this.updateSearchWizard();
      return;
    }

    console.log(this.searchText, "searchText---");

    // For non-empty value, validate and fetch if valid
    if (this.validateInput(value)) {
      this.updateSearchWizard();
    }
  }

  /**
   * Modified onSearchTextChange to use debounce
   */
  onSearchTextChange(value: string) {
    // Emit the value to the subject for debounced processing
    this.searchSubject.next(value);
  }

  updateSearchWizard() {
    // Double-check validation before making API call
    if (this.searchText && this.searchText.trim() !== '' && !this.validateInput(this.searchText)) {
      return;
    }

    this.getDrugData();
  }


  onSearchCriteriaChange() {
    if (this.validateInput(this.searchText)) {
      this.getDrugData();
      this.updateSearchWizard();
    }
  }
  openImportWizardFileUpload() {
    const dialogRef = this.dialog.open(FileUploadComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
    });
  }
  openImportWizardNewDrug() {

    const dialogRef = this.dialog.open(ImportWizardAddNewDrugComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.getDrugData();
        this.refreshChildComponents();
      }
    });

  }

  openImportWizardNewWizardDrug() {
    const dialogRef = this.dialog.open(ImportWizardNewDrugComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
          this.getDrugData();
          this.refreshChildComponents();
    });
  }

  getDrugData() {
    this.ngxLoader.start();
    // For non-empty values, validate before API call
    if (this.searchText && this.searchText.trim() !== '' && !this.validateInput(this.searchText)) {
      this.ngxLoader.stop();
      return;
    }

    this.rpoService.getDrugData(
      this.dataSourceId,
      this.searchText,
      this.permanentQuarantineValue,
      this.countryId,
      this.qReasonId,
      this.selectedSearchCriteria,
      this.modifiedBy ?? ''
    ).subscribe({
      next: (result) => {
        const initializedData = result.data?.map((item: any) => ({
          ...item,
          isExpanded: item.name.split('(')[0].trim() === 'SEARCH RESULTS' && !!this.searchText // Expand search section only when a search term exists
        }));
        this.dataSource = new MatTableDataSource(initializedData);
        this.ngxLoader.stop();
      },
      error: (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        const errorMessage = error.error?.message || error.message || 'An error occurred';
        this.toastService.openToast(
          errorMessage,
          constants.ToastPanelType.error,
          2
        );
      }
    });
  }
  handleSearchCountUpdate(count: number | null | undefined) {
    this.searchResultsCount = Number.isFinite(Number(count)) ? Number(count) : 0;
  }
  handleQuarantineCountUpdate(count: number | null | undefined) {
    this.QuarantineResultsCount = Number.isFinite(Number(count)) ? Number(count) : 0;
  }

  handleDcrCountUpdate(count: number | null | undefined){
    this.dcrResultsCount = Number.isFinite(Number(count)) ? Number(count) : 0;
  }

  getCountry() {
    this.rpoService.getCountry().subscribe((result) => {

      const countries = result.data;
      if (countries.length > 1) {
        // Add 'All' key when more than one assigned...
        result.data.unshift(
          {
            "key":-1,
            "value":"All"
          }
        );
        this.countryId = -1;
      } else if (countries.length === 1) {
        // Otherwise, automatically select assign country if exists...
        this.countryId = countries[0]["key"];
      }
      this.listOfCountry = countries;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

  getQuarantineReasonList() {
    this.rpoService.getQuarantineReasonList().subscribe((result) => {
      const allQReasonData = result.data;

       if (allQReasonData.length > 1) {
        // Add 'All' key when more than one assigned...
        result.data.unshift(
          {
            "value":-1,
            "label":"All"
          }
        );
        this.qReasonId = -1;
      } else if (allQReasonData.length === 1) {
        // Otherwise, automatically select assign country if exists...
        this.qReasonId = allQReasonData[0]["value"];
      }

      this.listOfQReason = allQReasonData;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

  getModifiersList() {
    this.ngxLoader.start();
    this.rpoService.getModifierList().subscribe((result) => {
      this.ngxLoader.stop();
      const allModifiersData = result.data;

       if (allModifiersData.length >= 0) {
        // Add 'All' key when more than one assigned...
        result.data.unshift("All");
      }

      this.listOfModifiers = allModifiersData;
      this.modifiedBy = allModifiersData[0];
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

  getDataSourceFilter() {
    this.rpoService.getDataSourceFilter().subscribe((result) => {
      const allDataSources = (result.data || []).map((item: any) => ({
        ...item,
        key: Number(item?.key)
      }));
      this.listOfDataSourceFilter = allDataSources;
      const allOptions = allDataSources.filter((item: any) => {
        const label = String(item?.value ?? item?.label ?? '').trim().toLowerCase();
        return label === 'all';
      });
      const defaultAll = allOptions[1] ?? allOptions[0];
      this.dataSourceId = Number.isFinite(defaultAll?.key) ? defaultAll.key : -1;

      // Trigger initial load only after datasource default is settled.
      this.getDrugData();
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

}




